import SearchResult from 'visuris/Data/Entities/SearchResult';

export default class SearchResponse {
    public numberOfResults: number = null;
    public iconPath: string = null;
    public results: SearchResult[] = null;
}